import Vue from "vue";
import Vuex from "vuex";
import api_client, { set_auth_token_hdr, reset_logout_timer, clear_logout_timer } from '../services/api.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    is_logged_in: false,
  },
  
  actions: {
    login({}, credentials) {
      return api_client.run_post_query('/login', credentials)
      .then(({ data }) => {
        localStorage.setItem('access_token', data.access_token);
        set_auth_token_hdr(data.access_token);
        this.state.is_logged_in = true;
        reset_logout_timer();
      });
    },

    logout() {
      clear_logout_timer();
      localStorage.removeItem('access_token');
      set_auth_token_hdr(null);
      this.state.is_logged_in = false;
    },

    reload_login_state() {
      const access_token = localStorage.getItem('access_token');
      if (access_token) {
        set_auth_token_hdr(access_token);
        this.state.is_logged_in = true;
        reset_logout_timer();
      }
    },
  },
});
